module.exports = __webpack_public_path__ + "static/media/sports_25.58fffaea.jpg";